import React from 'react'
import LocalShippingIcon from '@material-ui/icons/LocalShipping'
import { connect } from 'react-redux'
import { obtenerColorEspacio } from '../../../../config/colores'

function EstimacionEspacioDisponible (props) {
  const { espacioAcumulado, espacioDisponible, netoPromedio, espacioMaximoElevador } = props

  const netoPromedioTn = netoPromedio / 1000
  const espacioMaximo = Math.round(espacioMaximoElevador / netoPromedioTn)
  const acumulado = espacioAcumulado || 0
  const espacioDisp = espacioDisponible - acumulado
  const disponible = (espacioDisp < espacioMaximo) ? espacioDisp : espacioMaximo

  return (
    <>
      { !isNaN(disponible) &&
        <div
          style={{
            color: obtenerColorEspacio(disponible),
            height: '100%',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {disponible}
          <LocalShippingIcon style={{ margin: '0 5px' }} />
        </div>
      }
    </>
  )
}

const mapStateToProps = (state) => ({
  espacioDisponible: state.stock.espacioDisponibleElevador,
  netoPromedio: state.camionesIngreso.promedioPesoCamion,
  espacioMaximoElevador: state.stock.espacioMaximoElevador
})

const withRedux = connect(mapStateToProps, null)
export default withRedux(EstimacionEspacioDisponible)
